<main class="main-home-secton">
  <div class="bg">
    <div class="container">
      <div class="about">
        <div class="row">
          <div class="col-lg-6">
            <div>
              <h2 class="animated bounceInLeft" style="animation-delay: 1s">
                About StartupTN CSR SPOT
              </h2>
              <p class="animated bounceInLeft" style="animation-delay: 2s">
                StartupTN CSR Spot will serve as the one stop platform for
                showcasing impactful CSR projects of Tamil Nadu Incubation
                Centres to Corporates for effective utilisation of CSR.
              </p>
            </div>
            <div>
              <button
                class="corprate-btn"
                mat-raised-button
                color="primary"
                routerLink="/partner-register"
              >
                PARTNER WITH STARTUPTN FOR CSR
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <img src="assets/images/CSR 2.png" alt="" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="csrs-section">
    <div class="container">
      <div class="about">
        <div class="row">
          <div class="collaborate">
            <div class="row">
              <div class="col-lg-6">
                <div>
                  <h2 class="animated bounceInLeft" style="animation-delay: 1s">
                    Why should a Corporate collaborate with Incubators for CSR
                    through StartupTN?
                  </h2>
                  <p class="animated bounceInLeft" style="animation-delay: 3s">
                    Contributing to Corporate Social Responsibility (CSR)
                    initiatives at Tamil Nadu incubation centres through
                    StartupTN provides a unique and impactful avenue for
                    businesses to align their goals with societal well-being.
                  </p>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="csrs_list">
                  <ul class="list-unstyled">
                    <span> <li>Nurturing Innovation and Growth</li></span>
                    <span> <li>Positive Brand Image</li></span>
                    <span> <li>Talent Attraction and Retention</li></span>
                    <span> <li>Addressing Social Challenges</li></span>
                    <span> <li>Long-Term Sustainability</li></span>
                    <span> <li>Inclusive Economic Development</li></span>
                    <span> <li>Local Community Engagement</li></span>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="assessment-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" style="width: 70%">
          <div class="text-center home-title mb-3">
            <h1>Assessment Domains</h1>
          </div>
          <div class="container mt-2">
            <div #widgetsContent class="initive-card-container middle">
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">1</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-1.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">
                  Management Strategy
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">2</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-2.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">Financial</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">3</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-3.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">
                  Knowledge & Expertise
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">4</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-4.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">Human Resources</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">5</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-5.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">
                  Physical Infrastructure
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">6</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-6.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">
                  Networking Ecosystem
                </p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">7</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-7.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">Social Impact</p>
              </div>
              <div class="col-lg-2 col-md-4 col-sm-6 initive-card">
                <div class="initive-card-number">8</div>
                <img
                  class="asscard-img"
                  align="center"
                  src="assets/images/ass-cardimg-8.png"
                  alt=""
                />
                <p class="initive-card-cont" align="center">Result & Outcome</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="tag-group">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <mat-tab-group mat-align-tabs="center">
            <mat-tab label="Quick Guide for Donor / Corporates ">
              <div class="display">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card sec-card">
                        <div class="icon-bg">
                          <i class="fas fa-handshake"></i>
                          <h5 class="m-2">STEP 1</h5>
                          <p>
                            Click on
                            <a routerLink="/partner-register"
                              >PARTNER WITH STARTUPTN FOR CSR</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card sec-card">
                        <div class="icon-bg">
                          <i class="fas fa-user"></i>
                          <h5 class="m-2">STEP 2</h5>
                          <p>Register by entering your CIN number/ Email ID</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card sec-card">
                        <div class="icon-bg">
                          <i class="fas fa-envelope"></i>
                          <h5 class="m-2">STEP 3</h5>
                          <p>
                            You will receive an email with Login and Password
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card">
                        <div class="icon-bg">
                          <i class="fas fa-key"></i>
                          <h5 class="m-2">STEP 4</h5>
                          <p>
                            Log into
                            <a href="">https://startuptnincubators.com/</a> with
                            your login ID and password under CORPORATE LOGIN
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card sec-card">
                        <div class="icon-bg">
                          <i class="fas fa-search"></i>
                          <h5 class="m-2">STEP 5</h5>
                          <p>Search for project based on Incubators</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                      <div class="csrs-card sec-card">
                        <div class="icon-bg">
                          <i class="fas fa-file-alt"></i>
                          <h5 class="m-2">STEP 6</h5>
                          <p>Click to choose one or more projects</p>
                        </div>
                      </div>
                    </div>
                    <div
                      mat-align-tabs="center"
                      class="col-lg-4 col-md-4 col-sm-6 mt-3 center-card"
                    >
                      <div class="csrs-card">
                        <div class="icon-bg">
                          <i class="fas fa-star"></i>
                          <h5 class="m-2">STEP 7</h5>
                          <p>
                            You will receive a Congratulatory Message and
                            further steps for a discovery call with the
                            Incubator and StartupTN team to implement the CSR
                            Project
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Quick Guide for Incubators">
              <div class="display">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <div class="csrs-card incub-card">
                        <div class="icon-bg">
                          <i class="fas fa-cloud-upload-alt"></i>
                          <h5 class="m-2">STEP 1</h5>
                          <p>
                            Click on “UPLOAD CSR PROJECT” in your Incubator
                            Dashboard
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <div class="csrs-card incub-card">
                        <div class="icon-bg">
                          <i class="fas fa-file-alt"></i>
                          <h5 class="m-2">STEP 2</h5>
                          <p>Enter the relevant details about the project</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <div class="csrs-card incub-card">
                        <div class="icon-bg">
                          <i class="fas fa-envelope"></i>
                          <h5 class="m-2">STEP 3</h5>
                          <p>
                            You will receive a confirmation email once the
                            project has been approved for showcase in the portal
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mt-4 center-card">
                      <div class="csrs-card">
                        <div class="icon-bg">
                          <i class="fas fa-star"></i>
                          <h5 class="m-2">STEP 4</h5>
                          <p>
                            You will receive updates from StartupTN team for a
                            discovery call on the implementation of your
                            proposal when your project is selected by a
                            corporate
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</main>
<app-footer></app-footer>
